import {
    Component,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    OnInit,
    forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SelectItem } from './select-item';
import { stripTags } from './select-pipes';
import { OptionsBehavior } from './select-interfaces';
import { escapeRegexp } from './common';
import {TranslateService} from '@ngx-translate/core';
import {StringUtils} from '../../../../shared';

@Component({
    selector: 'bsp-select',
    styleUrls: [ '../element.select.scss' ],
    templateUrl: './select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NgSelectComponent),
            multi: true
        }
    ]
})

export class NgSelectComponent implements OnInit, ControlValueAccessor {
    @Input() public errorCode: any;                     //invalid 처리를 위한 코드
    @Input() public placeholder = '';
    public idField = 'id';
    public textField = 'text';
    public nameField = 'name';
    public emailField = 'email';
    public roleField = 'role';
    public useYnField = 'useYn';
    public prmsYnField = 'prmsYn';
    public flagField = 'flag';
    public childrenField = 'children';
    @Input() public multiple = false;
    @Input() public grouping = false;
    @Input() public checkable = false;
    @Input() public tagUseYN = true;
    @Input() public tagWithImage = true;
    @Input() public whereItIs: String;
    @Input() public mandatory = true;
    @Input() public grpLabelNm = {users: '', schds: '', teams: '', rteams: ''};
    @Input()
    public set items(value: Array<any>) {
        if (!value) {
            this._items = this.itemObjects = [];
        } else {
            this._items = value.filter((item: any) => {
                if ((typeof item === 'string') || (typeof item === 'object' && item )) {
                    return item;
                }
            });
            this.itemObjects = this._items.map((item: any) => (typeof item === 'string' ? new SelectItem(item) : new SelectItem({
                id: item[this.idField],
                text: item[this.textField],
                name: item[this.nameField],
                email: item[this.emailField],
                role: item[this.roleField],
                useYn: item[this.useYnField],
                prmsYn: item[this.prmsYnField],
                flag: item[this.flagField],
                children: item[this.childrenField]
            })));
        }
    }

    public get items() {
        return this._items;
    }

    @Input()
    public set disabled(value: boolean) {
        this._disabled = value;
        if (this._disabled === true) {
            this.hideOptions();
        }
    }

    public get disabled(): boolean {
        return this._disabled;
    }

    @Input()
    public set active(selectedItems: Array<any>) {
        // console.log('active: ', selectedItems);
        if (!selectedItems || selectedItems.length === 0) {
            this._active = [];
        } else {
            const areItemsStrings = typeof selectedItems[0] === 'string';

            this._active = selectedItems.map((item: any) => {
                const data = areItemsStrings ? item : {
                    id: item[this.idField],
                    text: item[this.textField],
                    name: item[this.nameField],
                    email: item[this.emailField],
                    role: item[this.roleField],
                    useYn: item[this.useYnField],
                    prmsYn: item[this.prmsYnField],
                    flag: item[this.flagField]
                };

                return new SelectItem(data);
            });
        }
    }

    @Input()
    public allow_duplicates = false;

    @Output() public data: EventEmitter<any> = new EventEmitter(true);
    @Output() public selected: EventEmitter<any> = new EventEmitter(true);
    @Output() public removed: EventEmitter<any> = new EventEmitter(true);
    @Output() public opened: EventEmitter<any> = new EventEmitter();
    @Output() public bspClicked: EventEmitter<any> = new EventEmitter();
    @Output() public deleteClicked: EventEmitter<any> = new EventEmitter();

    public noTeam = false;
    public noSchedule = false;
    public noUser = false;
    public options: Array<SelectItem> = [];
    public itemObjects: Array<SelectItem> = [];
    public activeOption: SelectItem;
    public element: ElementRef;

    public get active(): Array<any> {
        return this._active;
    }

    private set optionsOpened(value: boolean){
        this._optionsOpened = value;
        this.opened.emit(value);
    }

    private get optionsOpened(): boolean{
        return this._optionsOpened;
    }

    protected onChange: any = Function.prototype;
    protected onTouched: any = Function.prototype;

    private inputMode = false;
    private _optionsOpened = false;
    private behavior: OptionsBehavior;
    private inputValue = '';
    private _items: Array<any> = [];
    private _disabled = false;
    private _active: Array<SelectItem> = [];

    public constructor(element: ElementRef
                       , private sanitizer: DomSanitizer
                        , private translate: TranslateService) {
        this.element = element;
        this.clickedOutside = this.clickedOutside.bind(this);
    }

    public sanitize(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public inputEvent(e: any, isUpMode: boolean = false): void {
        if ($('button.accordion').hasClass('expand')) {
            $('button.accordion').removeClass('expand');
        }
        // tab
        if (e.keyCode === 9) {
            return;
        }
        if (isUpMode && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 38 ||
            e.keyCode === 40 || e.keyCode === 13)) {
            e.preventDefault();
            return;
        }
        // backspace
        if (!isUpMode && e.keyCode === 8) {
            // let el:any = this.element.nativeElement.querySelector('div.multi_selector > input');
            // if (!el.value || el.value.length <= 0) {
            //     if (this.active.length > 0) {
            //         this.remove(this.active[this.active.length - 1]);
            //     }
            //     e.preventDefault();
            //     return;
            // }
        }
        // esc
        if (!isUpMode && e.keyCode === 27) {
            this.hideOptions();
            this.element.nativeElement.children[0].focus();
            e.preventDefault();
            return;
        }
        // del
        if (!isUpMode && e.keyCode === 46) {
            // if (this.active.length > 0) {
            //     this.remove(this.active[this.active.length - 1]);
            // }
            // e.preventDefault();
            // return;
        }
        // left
        if (!isUpMode && e.keyCode === 37 && this._items.length > 0) {
            this.behavior.first();
            e.preventDefault();
            return;
        }
        // right
        if (!isUpMode && e.keyCode === 39 && this._items.length > 0) {
            this.behavior.last();
            e.preventDefault();
            return;
        }
        // up
        if (!isUpMode && e.keyCode === 38) {
            this.behavior.prev();
            e.preventDefault();
            return;
        }
        // down
        if (!isUpMode && e.keyCode === 40) {
            this.behavior.next();
            e.preventDefault();
            return;
        }
        // enter
        if (!isUpMode && e.keyCode === 13) {
            if (this.active.indexOf(this.activeOption) === -1) {
                this.selectActiveMatch(e);
                this.behavior.next();
            }
            // input data 삭제
            $('div.multi_selector > div > input').val('');

            e.preventDefault();
            return;
        }

        const target = e.target || e.srcElement;
        if (target && target.value) {
            this.inputValue = target.value;
            this.behavior.filter(new RegExp(escapeRegexp(this.inputValue), 'ig'));
            this.doEvent('typed', this.inputValue);
        } else {
            this.open();
        }

        if (this.grouping) {
            let teamCnt = 0;
            let schdCnt = 0;
            let userCnt = 0;
            this.options.forEach(o => {
                switch (o.flag) {
                    case 'NRCVR010': userCnt++; break;
                    case 'NRCVR020': schdCnt++; break;
                    case 'NRCVR040':
                    case 'NRCVR050': teamCnt++; break;
                    default: break;
                }
            });
            this.noTeam = teamCnt === 0 ? true : false;
            this.noSchedule = schdCnt === 0 ? true : false;
            this.noUser = userCnt === 0 ? true : false;
        }
    }

    public ngOnInit(): any {
        this.behavior = (this.firstItemHasChildren) ?
            new ChildrenBehavior(this) : new GenericBehavior(this, this.translate);
    }

    public remove(item: SelectItem): void {
        if (this._disabled === true) {
            return;
        }
        if (this.multiple === true && this.active) {
            // const index = this.active.indexOf(item);
            // this.active.splice(index, 1);

            /* id 로 비교하여 삭제 처리하는 것으로 변경 */
            const datas = this.active;
            this.active.forEach((row, index) => {
                if (row.id === item.id) {
                    datas.splice(index, 1);
                }
            });

            this.data.next(this.active);

            if (this.tagUseYN === false) {
                this.errorCode = false;
            }
        }
        if (this.multiple === false) {
            this.active = [];
            this.data.next(this.active);
        }

        this.doEvent('removed', item);

        if (this.active.length === 0) {
            // inputbox 에 빨간 테두리 생성
            this.errorCode = true;
        }
    }

    /* Event Emitter 와 비슷한 역할 */
    public doEvent(type: string, value: any): void {
        if ((this as any)[type] && value) {
            (this as any)[type].next(value);
        }

        this.onTouched();
        if (type === 'selected' || type === 'removed') {
            this.onChange(this.active);
        }
    }

    public clickedOutside(): void {
        this.inputMode = false;
        this.optionsOpened = false;
    }

    public get firstItemHasChildren(): boolean {
        return this.itemObjects[0] && this.itemObjects[0].hasChildren();
    }

    public writeValue(val: any): void {
        this.active = val;
        this.data.emit(this.active);
    }

    public registerOnChange(fn: (_: any) => {}): void {
        this.onChange = fn;
    }
    public registerOnTouched(fn: () => {}): void {
        this.onTouched = fn;
    }

    protected matchClick(e: any): void {
        this.bspClicked.emit(e);

        if (this._disabled === true) {
            return;
        }
        this.inputMode = !this.inputMode;
        if (this.inputMode === true && ((this.multiple === true && e) || this.multiple === false)) {
            this.focusToInput();
            this.open();
        }
    }

    protected  mainClick(event: any): void {
        if (this.inputMode === true || this._disabled === true) {
            return;
        }
        if (event.keyCode === 46) {
            event.preventDefault();
            this.inputEvent(event);
            return;
        }
        if (event.keyCode === 8) {
            event.preventDefault();
            this.inputEvent(event, true);
            return;
        }
        if (event.keyCode === 9 || event.keyCode === 13 ||
            event.keyCode === 27 || (event.keyCode >= 37 && event.keyCode <= 40)) {
            event.preventDefault();
            return;
        }
        this.inputMode = true;
        /* 한글을 입력해도 keyCode 는 영문으로 넘어오므로 srcElement.value 사용함 */
        // let value = String
        //     .fromCharCode(96 <= event.keyCode && event.keyCode <= 105 ? event.keyCode - 48 : event.keyCode)
        //     .toLowerCase();
        const value = event.srcElement.value;
        this.focusToInput(value);
        this.open();
        const target = event.target || event.srcElement;
        target.value = value;
        this.inputEvent(event);
    }

    protected  selectActive(value: SelectItem): void {
        this.activeOption = value;
    }

    protected  isActive(value: SelectItem): boolean {
        return this.activeOption.id === value.id;
    }

    protected removeClick(value: SelectItem, event: any): void {
        this.deleteClicked.emit(event);
        event.stopPropagation();
        this.remove(value);
    }

    private focusToInput(value: string = ''): void {
        setTimeout(() => {
            const el = this.element.nativeElement.querySelector('div.ui-select-container > input');
            if (el) {
                el.focus();
                el.value = value;
            }
        }, 0);
    }

    private open(): void {
        //bsp-select에 중복선택기능 추가
        if (!this.allow_duplicates) {
            this.options = this.itemObjects.filter((option: SelectItem) => (
                !this.active.find((o: SelectItem) =>
                    option.text === o.text
                )
            ));
        } else {
            this.options = this.itemObjects;
        }

        if (this.options.length > 0) {
            this.behavior.first();
        }
        this.optionsOpened = true;
    }

    private hideOptions(): void {
        // this.inputMode = false;
        this.optionsOpened = false;
    }

    private selectActiveMatch(e: any): void {
        this.selectMatch(this.activeOption, e);
    }

    private selectMatch(value: SelectItem, e: any): void {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (this.options.length <= 0) {
            return;
        }
        if (this.multiple === true) {
            // input data 삭제
            $('div.multi_selector > div > input').val('');
            this.active.push(value);
            this.data.next(this.active);
        }
        if (this.multiple === false) {
            this.active[0] = value;
            this.data.next(this.active[0]);
        }
        if (this.active.length > 0 && this.mandatory) {
            try {
                // (에스컬레이션 생성) 저장 버튼 클릭 시 생성한 빨간 테두리 제거
                if (e.keyCode === 13) {
                    e.srcElement.setAttribute('invalid', false);
                } else {
                    // Team 목록은 DOM 구조가 달라서 에러 발생. ㅠ
                    const index = this.multiple === true ? 3 : 1;
                    e.srcElement.parentElement.parentElement.parentElement.childNodes[index].setAttribute('invalid', false);
                }
            } catch (ex) {
                console.error(ex);
            }
            // inputbox 에 빨간 테두리 제거
            this.errorCode = false;
        }

        this.doEvent('selected', value);

        this.hideOptions();
        if (this.multiple === true) {
            this.focusToInput('');
        } else {
            this.focusToInput(stripTags(value.text));

            // input data 삭제
            $('div.multi_selector.single > div > input').val('');
            /*
            if (this.multiple) {
                this.element.nativeElement.querySelector('.ui-select-container').focus();
            }
            */
        }
    }
    expandFold(e) {
        const $this = e.target;
        if (!$this.classList.contains('expand')) {
            $this.classList.add('expand');
        }else {
            $this.classList.remove('expand');
        }
    }
    isShowTagImagesItem(item) {
        return this.tagWithImage && item.useYn !== 'N' && item.name !== undefined;
    }
    isShowEmailTooltip(item) {
        return item.email && item.email !== item.name && StringUtils.isEmail(item.email);
    }
}

export class Behavior {
    public optionsMap: Map<string, number> = new Map<string, number>();

    public actor: NgSelectComponent;

    public constructor(actor: NgSelectComponent) {
        this.actor = actor;
    }

    public fillOptionsMap(): void {
        this.optionsMap.clear();
        let startPos = 0;
        this.actor.itemObjects
            .map((item: SelectItem) => {
                startPos = item.fillChildrenHash(this.optionsMap, startPos);
            });
    }

    public ensureHighlightVisible(optionsMap: Map<string, number> = void 0): void {
        const container = this.actor.element.nativeElement.querySelector('.ui-select-choices-content');
        if (!container) {
            return;
        }
        const choices = container.querySelectorAll('.ui-select-choices-row');
        if (choices.length < 1) {
            return;
        }
        const activeIndex = this.getActiveIndex(optionsMap);
        if (activeIndex < 0) {
            return;
        }
        const highlighted: any = choices[activeIndex];
        if (!highlighted) {
            return;
        }
        const posY: number = highlighted.offsetTop + highlighted.clientHeight - container.scrollTop;
        const height: number = container.offsetHeight;
        if (posY > height) {
            container.scrollTop += posY - height;
        } else if (posY < highlighted.clientHeight) {
            container.scrollTop -= highlighted.clientHeight - posY;
        }
    }

    private getActiveIndex(optionsMap: Map<string, number> = void 0): number {
        let ai = this.actor.options.indexOf(this.actor.activeOption);
        if (ai < 0 && optionsMap !== void 0) {
            ai = optionsMap.get(this.actor.activeOption.id);
        }
        return ai;
    }
}

export class GenericBehavior extends Behavior implements OptionsBehavior {
    public constructor(actor: NgSelectComponent,
                       private translate: TranslateService) {
        super(actor);
    }

    public first(): void {
        this.actor.activeOption = this.actor.options[0];
        super.ensureHighlightVisible();
    }

    public last(): void {
        this.actor.activeOption = this.actor.options[this.actor.options.length - 1];
        super.ensureHighlightVisible();
    }

    public prev(): void {
        const index = this.actor.options.indexOf(this.actor.activeOption);
        this.actor.activeOption = this.actor
            .options[index - 1 < 0 ? this.actor.options.length - 1 : index - 1];
        super.ensureHighlightVisible();
    }

    public next(): void {
        const index = this.actor.options.indexOf(this.actor.activeOption);
        this.actor.activeOption = this.actor
            .options[index + 1 > this.actor.options.length - 1 ? 0 : index + 1];
        super.ensureHighlightVisible();
    }

    public filter(query: RegExp): void {
        const options = this.actor.itemObjects
            .filter((option: SelectItem) => {
                return stripTags(this.translate.instant(option.text)).match(query) &&
                    (this.actor.multiple === false ||
                        (this.actor.multiple === true && this.actor.active.map((item: SelectItem) => item.id).indexOf(option.id) < 0));
            });
        this.actor.options = options;
        if (this.actor.options.length > 0) {
            this.actor.activeOption = this.actor.options[0];
            super.ensureHighlightVisible();
        }
    }
}

export class ChildrenBehavior extends Behavior implements OptionsBehavior {
    public constructor(actor: NgSelectComponent) {
        super(actor);
    }

    public first(): void {
        this.actor.activeOption = this.actor.options[0].children[0];
        this.fillOptionsMap();
        this.ensureHighlightVisible(this.optionsMap);
    }

    public last(): void {
        this.actor.activeOption =
            this.actor
                .options[this.actor.options.length - 1]
                .children[this.actor.options[this.actor.options.length - 1].children.length - 1];
        this.fillOptionsMap();
        this.ensureHighlightVisible(this.optionsMap);
    }

    public prev(): void {
        const indexParent = this.actor.options
            .findIndex((option: SelectItem) => this.actor.activeOption.parent && this.actor.activeOption.parent.id === option.id);
        const index = this.actor.options[indexParent].children
            .findIndex((option: SelectItem) => this.actor.activeOption && this.actor.activeOption.id === option.id);
        this.actor.activeOption = this.actor.options[indexParent].children[index - 1];
        if (!this.actor.activeOption) {
            if (this.actor.options[indexParent - 1]) {
                this.actor.activeOption = this.actor
                    .options[indexParent - 1]
                    .children[this.actor.options[indexParent - 1].children.length - 1];
            }
        }
        if (!this.actor.activeOption) {
            this.last();
        }
        this.fillOptionsMap();
        this.ensureHighlightVisible(this.optionsMap);
    }

    public next(): void {
        const indexParent = this.actor.options
            .findIndex((option: SelectItem) => this.actor.activeOption.parent && this.actor.activeOption.parent.id === option.id);
        const index = this.actor.options[indexParent].children
            .findIndex((option: SelectItem) => this.actor.activeOption && this.actor.activeOption.id === option.id);
        this.actor.activeOption = this.actor.options[indexParent].children[index + 1];
        if (!this.actor.activeOption) {
            if (this.actor.options[indexParent + 1]) {
                this.actor.activeOption = this.actor.options[indexParent + 1].children[0];
            }
        }
        if (!this.actor.activeOption) {
            this.first();
        }
        this.fillOptionsMap();
        this.ensureHighlightVisible(this.optionsMap);
    }

    public filter(query: RegExp): void {
        const options: Array<SelectItem> = [];
        const optionsMap: Map<string, number> = new Map<string, number>();
        let startPos = 0;
        for (let si of this.actor.itemObjects) {
            const children: Array<SelectItem> = si.children.filter((option: SelectItem) => query.test(option.text));
            startPos = si.fillChildrenHash(optionsMap, startPos);
            if (children.length > 0) {
                const newSi = si.getSimilar();
                newSi.children = children;
                options.push(newSi);
            }
        }
        this.actor.options = options;
        if (this.actor.options.length > 0) {
            this.actor.activeOption = this.actor.options[0].children[0];
            super.ensureHighlightVisible(optionsMap);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/form/select/ng-select/select.component.ts